import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {LocaleInfoModel} from "../../core/components/localization/interface";
import {isBlank} from "../../helpers/stringHelper";
import {getLocaleInfoFromLocal, setLocaleToLocal} from "../../core/localization/localizationHelper";
import {LocaleType} from "../../core/localization/intertace";
import {defaultLocalCode} from "../../core/localization/defaults";

type stringDictionary = {
    [key: string]: string
};

type languageDictionary = {
    [key: string]: stringDictionary
};


interface LocalizationModel extends LocaleInfoModel{
    dictionary: stringDictionary
    allDictionary: languageDictionary,
    queueTranslate: string[]
}


const initalDefault = () => {
    const language = getLocaleInfoFromLocal();
    return {
        dictionary: {},
        allDictionary: {},
        queueTranslate: [],
        ...language
    } as LocalizationModel

}
let initialState: LocalizationModel = initalDefault();


export const localizationSlice = createSlice({
    name: "localization",
    initialState: initialState,
    reducers: {
        setLanguageDictionary: (state, action: PayloadAction<stringDictionary>) => {
            state.dictionary = action.payload;
            return state;
        },
        clearCurrentDictionary: (state) => {
            state.dictionary = {}
            return state;
        },
        clearLanguageDictionary: (state,action:PayloadAction<string>) => {
            const languageCode = action.payload ?? (state.languageCode ?? defaultLocalCode);
            if(state.languageCode ===languageCode){
                if(state.allDictionary[languageCode]){
                    delete   state.allDictionary[languageCode];
                }
            }
            state.dictionary ={};
            return state;
        },
/*        addQueue: (state, action: PayloadAction<{ word: string }>) => {
            if (!state.queueTranslate.includes(action.payload.word)) {
                if (!(isBlank(action.payload.word) || action.payload.word.startsWith("#"))) {
                    state.queueTranslate.push(action.payload.word);
                }

            }

            return state;

        },*/
        addWord: (state, action: PayloadAction<{ word: string, translateWord: string }>) => {
            state.dictionary[action.payload.word] = action.payload.translateWord;
            //state.queueTranslate.indexOf(action.payload.word);
            return state;

        },
        addWords: (state, action: PayloadAction<{ words: { [key: string]: string } }>) => {

            if(action?.payload?.words){
                for (let word in action?.payload?.words) {
                    state.dictionary[word] = action?.payload?.words[word];
                }

            }
            return state;

        },
        setLocaleCode: (state, action: PayloadAction<LocaleType>) => {
            const localeCode = action.payload ?? defaultLocalCode;

            if(!isBlank(state.languageCode)){
                state.allDictionary[state.languageCode] = state.dictionary;
            }
            if(state.allDictionary[localeCode] !== undefined){
                state.dictionary = state.allDictionary[localeCode];
            }else{
                state.dictionary ={};
            }

            //localStorage.setItem('locale', languageCode);
            setLocaleToLocal(localeCode);
            const localeInfo = getLocaleInfoFromLocal();
            state.languageCode = localeInfo.languageCode;
            state.name = localeInfo.name;
            state.icon = localeInfo.icon;
            state.locale = localeInfo.locale;

            return state;
        },

    }
})

export const {setLanguageDictionary, addWords,addWord,clearCurrentDictionary, setLocaleCode,clearLanguageDictionary} = localizationSlice.actions;

export default localizationSlice.reducer;
